import { Fragment, useState, useEffect } from "react";
import { Modal, notification, Button } from "antd";
import { TitleHeader, Searcher, TableAntd } from "../../components";
import { ReloadOutlined } from "@ant-design/icons";
import { Redirect } from "react-router-dom";
import { useAuth } from "../../utils/useAuth";
import { getAll } from "../../api/user";
import { createColumns } from "./formatTable";
import AddUser from "./AddUser";
import EditUser from "./EditUser";
import DeleteUser from "./DeleteUser";

function Users() {
  const { isAdmin } = useAuth();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [filterTable, setFilterTable] = useState(null);
  const [page, setPage] = useState(1);
  const [modalTitle, setModalTitle] = useState("");

  const [dataToTable, setDataToTable] = useState([]);
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDataToTable = async () => {
    setIsLoading(true);

    getAll()
      .then((res) => {
        setDataToTable(res.payload);
      })
      .catch((err) => {
        notification.error({
          message: "Problemas con la solicitud",
          description: err.message
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchDataToTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  const showAddModal = () => {
    setIsModalVisible(true);
    setModalTitle("Agregar usuario");
    setModalContent(<AddUser closeModal={closeModal} />);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  const showEditModal = (usuario) => {
    setIsModalVisible(true);
    setModalTitle("Editar usuario");
    setModalContent(
      <EditUser usuario={usuario} closeModal={closeModal} setModalContent={setModalContent} />
    );
  };

  const showDeleteModal = (usuario) => {
    setIsModalVisible(true);
    setModalTitle("Eliminar usuario");
    setModalContent(<DeleteUser usuario={usuario} closeModal={closeModal} />);
  };

  if (!isAdmin) return <Redirect to="/app" />;

  const columnsToTable = createColumns(page, showEditModal, showDeleteModal);

  const search = (value) => {
    const tempFilterTable = dataToTable.filter((o) =>
      Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(value.toLowerCase()))
    );

    setFilterTable(tempFilterTable);
  };

  return (
    <Fragment>
      <TitleHeader
        title={
          <span className="flex gap-2 items-center">
            <h1 className="font-bold">Usuarios ({dataToTable.length})</h1>
            <Button
              size="small"
              icon={<ReloadOutlined />}
              onClick={() => setReload(!reload)}
            ></Button>
          </span>
        }
        buttonTitle="Nuevo usuario"
        onButtonTitleHeaderClick={showAddModal}
      />

      <Searcher onSearch={search} placeholder="Busca algún usuario" />

      <TableAntd
        columns={columnsToTable}
        dataSource={filterTable == null ? dataToTable : filterTable}
        setPage={setPage}
        isLoading={isLoading}
      />

      <Modal
        title={modalTitle}
        visible={isModalVisible}
        footer={null}
        onCancel={closeModal}
        destroyOnClose
        maskClosable={false}
      >
        {modalContent}
      </Modal>
    </Fragment>
  );
}

export default Users;
